import React from 'react'
import { useDispatch } from 'react-redux'
import { isloading } from '../redux/reducer/LoadingReducer'
import { downloadRegistrationPdf } from '../Utility/downloadRegistrationPdf'

const EmployeeEsmFormView = ({ data, showDownloadButton = true }) => {
  const dispatch = useDispatch()

  if (!data) {
    return <div>No data available</div>
  }

  const handleDownloadPdf = async () => {
    dispatch(isloading())
    try {
      await downloadRegistrationPdf()
    } finally {
      dispatch(isloading())
    }
  }

  const formatValue = (key, value) => {
    if (value === null || value === undefined) return 'N/A'
    if (key === 'dob' && value) return new Date(value).toLocaleDateString()
    if (key === 'totalAnnualFamilyIncome' && value) return `Rs. ${value.toLocaleString()}`
    if (key === 'appStatus' && value) {
      return <span className={`text-secondary fw-bold`}>{value}</span>
    }
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    return value
  }

  const renderRow = (label, value) => (
    <tr>
      <th className="bg-light" style={{ width: '30%' }}>{label}</th>
      <td>{value}</td>
    </tr>
  )

  return (
    <div className="container">
      <div className="card shadow-lg">
        <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background:"#008d96"}}>
          <h4 className="mb-0">Employee Details - ESM</h4>
          {showDownloadButton && (
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={handleDownloadPdf}
            >
              Download PDF
            </button>
          )}
        </div>
        <div className="card-body">
          
          {/* Important Information Section */}
          <div className="row mb-4">
            <div className="col-12">
              <h5 className="text-primary mb-3">Basic Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    {renderRow('Application Status', formatValue('appStatus', data.appStatus))}
                    {renderRow('PPP Id', formatValue('pppId', data.pppId))}
                    {renderRow('Member Id', formatValue('memberId', data.memberId))}
                    {renderRow('Force Number', formatValue('forceNumber', data.forceNumber))}
                    {renderRow('Force Name', formatValue('forceName', data.forceName))}
                    {renderRow('Full Name', formatValue('fullName', data.fullName))}
                    {renderRow('Service', formatValue('service', data.service))}
                    {renderRow('Type', formatValue('type', data.type))}
                    {renderRow('Rank', formatValue('rank', data.rank))}
                    {renderRow('Gender', formatValue('gender', data.gender))}
                    {renderRow('Date Of Birth', formatValue('dob', data.dob))}
                    {renderRow('Mobile', formatValue('mobile', data.mobile))}
                    {renderRow('Email', formatValue('email', data.email))}
                    {renderRow('State', formatValue('state', data.state))}
                    {renderRow('District', formatValue('district', data.district))}
                    {renderRow('Tehsil', formatValue('tehsil', data.tehsil))}
                    {renderRow('Village', formatValue('village', data.village))}
                    {renderRow('Address', formatValue('address', data.address))}
                    {renderRow('Pin Code', formatValue('pinCode', data.pinCode))}
                    {renderRow('Total Annual Family Income', formatValue('totalAnnualFamilyIncome', data.totalAnnualFamilyIncome))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div className="row">
            <div className="col-12">
              <h5 className="text-primary mb-3">Additional Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <tbody>
                    {renderRow("Father's Name", formatValue('fatherName', data.fatherName))}
                    {renderRow("Mother's Name", formatValue('motherName', data.motherName))}
                    {renderRow('Marital Status', formatValue('maritalStatus', data.maritalStatus))}
                    {renderRow('Alternate Mobile', formatValue('altMobile', data.altMobile))}
                    {renderRow('Benchmark Disability', formatValue('benchmarkDisability', data.benchmarkDisability))}
                    {renderRow('Disability Percentage', formatValue('disabilityPercentage', data.disabilityPercentage))}
                    {renderRow('Caste Category', formatValue('casteCategoryName', data.casteCategoryName))}
                    {renderRow('Caste Category Other', formatValue('casteCategoryOther', data.casteCategoryOther))}
                    {renderRow('Highest Qualification', formatValue('highestQualificationName', data.highestQualificationName))}
                    {renderRow('Qualification Other', formatValue('qualificationOther', data.qualificationOther))}
                    {renderRow('Current Engagement', formatValue('currentEngagementName', data.currentEngagementName))}
                    {renderRow('Engagement Other', formatValue('engagementOther', data.engagementOther))}
                    {renderRow('Income Verified', formatValue('incomeVerified', data.incomeVerified))}
                    {renderRow('Covered Under Socio Economic', formatValue('coveredUnderSocioEconomic', data.coveredUnderSocioEconomic))}
                    {renderRow('PPO No', formatValue('ppoNo', data.ppoNo))}
                    {renderRow('PPO Date', formatValue('ppoDate', data.ppoDate))}
                    {renderRow('Medical Category', formatValue('medicalCategory', data.medicalCategory))}
                    {renderRow('Enrollment Date', formatValue('enrollmentDate', data.enrollmentDate))}
                    {renderRow('Discharge Date', formatValue('dischargeDate', data.dischargeDate))}
                    {renderRow('Discharge Book No', formatValue('dischargeBookNo', data.dischargeBookNo))}
                    {renderRow('Unit Retired', formatValue('unitRetired', data.unitRetired))}
                    {renderRow('Remarks', formatValue('remarks', data.remarks))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          

        </div>
      </div>
    </div>
  )
}

export default EmployeeEsmFormView
